export default "__VITE_ASSET__BlPmuTRU__"